import builder from '../builder';
import HammerWench from '../../streamline-icons/bold/hammer-wench.svg';

export default builder('HammerWench', HammerWench);
